import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IconComponent } from '../../../icon/icon.component';
import { LoadingSpinnerComponent } from '../../../loading/loading-spinner/loading-spinner.component';
import { BaseProgressComponent } from '../base-progress.component';

@Component({
  selector: 'nrc-generic-progress',
  standalone: true,
  imports: [
    CommonModule,
    IconComponent,
    LoadingSpinnerComponent
  ],
  templateUrl: './generic-progress.component.html',
  styleUrl: './generic-progress.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GenericProgressComponent extends BaseProgressComponent {}
